import React, { useState } from 'react';
import { X, Star } from 'lucide-react';
import { API_BASE_URL } from '../../config';

const CreateReviewForm = ({ onClose, onSuccess }) => {
    const [text, setText] = useState('');
    const [rating, setRating] = useState(5);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!text.trim() || text.length < 10) {
            setError('Текст отзыва должен содержать минимум 10 символов');
            return;
        }
        
        if (text.length > 1000) {
            setError('Текст отзыва слишком длинный (максимум 1000 символов)');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${API_BASE_URL}/api/reviews/admin`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    text: text.trim(),
                    rating: rating,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.detail || 'Ошибка при создании отзыва');
            }

            if (onSuccess) {
                onSuccess();
            }
            onClose();
        } catch (err) {
            setError(err.message || 'Ошибка при создании отзыва');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6 border-b border-slate-200 flex justify-between items-center">
                    <h3 className="text-xl font-bold text-slate-800">Создать отзыв от администратора</h3>
                    <button
                        onClick={onClose}
                        className="text-slate-400 hover:text-slate-600"
                    >
                        <X size={24} />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="p-6 space-y-4">
                    {error && (
                        <div className="bg-rose-50 border border-rose-200 rounded-lg p-4 text-rose-600">
                            {error}
                        </div>
                    )}

                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                            Оценка
                        </label>
                        <div className="flex items-center gap-2">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <button
                                    key={star}
                                    type="button"
                                    onClick={() => setRating(star)}
                                    className={`p-2 rounded-lg transition-colors ${
                                        star <= rating
                                            ? 'text-yellow-500 bg-yellow-50'
                                            : 'text-slate-300 hover:text-yellow-400'
                                    }`}
                                >
                                    <Star size={24} fill={star <= rating ? 'currentColor' : 'none'} />
                                </button>
                            ))}
                            <span className="ml-2 text-sm text-slate-600">({rating}/5)</span>
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                            Текст отзыва *
                        </label>
                        <textarea
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            rows={6}
                            className="w-full px-4 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            placeholder="Введите текст отзыва (минимум 10 символов)"
                            required
                        />
                        <div className="mt-1 text-xs text-slate-500">
                            {text.length}/1000 символов
                        </div>
                    </div>

                    <div className="flex justify-end gap-3 pt-4 border-t border-slate-200">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 border border-slate-300 rounded-lg text-slate-700 hover:bg-slate-50"
                            disabled={loading}
                        >
                            Отмена
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
                            disabled={loading}
                        >
                            {loading ? 'Создание...' : 'Создать отзыв'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateReviewForm;
